import Location from "@/scenes/location";
import GameApp from "../../../index";
import "@/gui/components/room-access-screen";

export class NPCHandler {
  static async handle(data) {
    const currentScene = GameApp.game.currentScene as Location;

    data.npcs?.forEach((npc) => {
        console.log("yo", npc)
      currentScene.npcManager.setNPCPath(npc.id, npc.path);
    });
  }
}
